<template>
  <div class="ma-6">
    <DialogCreateCriteria ref="popupCreate" @criteriaCreated="fetchCriterias" />
    <DialogEditCriteria ref="popupEdit" @criteriaUpdated="fetchCriterias" />
    <div class="d-flex justify-space-between align-center mb-4">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Tên tiêu chí"
        single-line
        hide-details
        outlined
        dense
        class="mr-4"
        style="max-width: 300px"
      ></v-text-field>
      <v-btn outlined color="primary" dark @click="openPopupCreate">
        <v-icon left>mdi-plus</v-icon>
        Thêm tiêu chí đánh giá
      </v-btn>
    </div>
    <div class="mt-6">
      <v-row v-if="filteredEvaluateCriterias && filteredEvaluateCriterias.length > 0">
        <v-col cols="4" v-for="criteria in filteredEvaluateCriterias" :key="criteria.id">
          <v-card outlined height="100%" class="d-flex flex-column">
            <v-card-title class="text-h6 font-weight-bold">{{ criteria.title }}</v-card-title>
            <v-card-text class="flex-grow-1">
              <div>
                <p><strong>Loại:</strong> {{ getTypeText(criteria.type) }}</p>
                <p><strong>Bắt buộc:</strong> {{ criteria.isRequired ? 'Có' : 'Không' }}</p>
                <p v-if="criteria.selections && criteria.selections.length > 0">
                  <strong>Lựa chọn:</strong> {{ criteria.selections.join(', ') }}
                </p>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="editCriteria(criteria)">Sửa</v-btn>
              <v-btn text color="error" @click="confirmDeleteCriteria(criteria)">Xóa</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <div v-else class="mt-4">Không tìm thấy tiêu chí đánh giá phù hợp.</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogCreateCriteria from './DialogCreateCriteria.vue'
import DialogEditCriteria from './DialogEditCriteria.vue'

export default {
  components: {
    DialogCreateCriteria,
    DialogEditCriteria,
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapState('evaluateCriteria', ['evaluateCriterias']),
    sortedEvaluateCriterias() {
      return [...this.evaluateCriterias].sort((a, b) => a.title.localeCompare(b.title))
    },
    filteredEvaluateCriterias() {
      if (!this.search) {
        return this.sortedEvaluateCriterias
      }
      const searchLower = this.search.toLowerCase()
      return this.sortedEvaluateCriterias.filter(
        (criteria) =>
          criteria.title.toLowerCase().includes(searchLower) ||
          this.getTypeText(criteria.type).toLowerCase().includes(searchLower)
      )
    },
  },
  methods: {
    ...mapActions('evaluateCriteria', ['fetchEvaluateCriterias', 'deleteEvaluateCriteria', 'updateEvaluateCriteria']),
    openPopupCreate() {
      this.$refs.popupCreate.open()
    },
    async fetchCriterias() {
      try {
        await this.fetchEvaluateCriterias()
      } catch (error) {
        console.error('Error fetching criterias:', error)
      }
    },
    async confirmDeleteCriteria(criteria) {
      if (confirm('Bạn có chắc chắn muốn xóa tiêu chí này?')) {
        try {
          await this.deleteEvaluateCriteria(criteria.id)
          this.fetchCriterias()
        } catch (error) {
          console.error('Error deleting criteria:', error)
        }
      }
    },
    editCriteria(criteria) {
      this.$refs.popupEdit.open(criteria)
    },
    getTypeText(type) {
      const typeMap = {
        string: 'Đánh giá tự nhập',
        number: 'Đánh giá theo điểm số',
        multiplechoice: 'Đánh giá theo tiêu chí (chọn nhiều)',
        singlechoice: 'Đánh giá theo tiêu chí (chọn một)',
      }
      return typeMap[type] || type
    },
  },
  created() {
    this.fetchCriterias()
  },
}
</script>
